import React from 'react';

const Icon = ({ d, size = 16, strokeWidth = 1.75 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    </svg>
);

const icons = {
    general: ['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z'],
    masterData: ['M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z'],
    tickets: ['M20 12V22H4V12', 'M22 7H2v5h20V7z', 'M12 22V7', 'M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z', 'M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z'],
    vendors: ['M17 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', 'M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
};

const settingsCards = [
    {
        id: 'general',
        title: 'General Settings',
        description: 'Configure your basic workspace profile and system preferences.',
        iconKey: 'general',
        pageKey: 'general-settings',
    },

    {
        id: 'master-data',
        title: 'Master Data',
        description: 'Manage systemic lists like vehicle types, fuel types, and more.',
        iconKey: 'masterData',
        pageKey: 'master-data',
    },
    {
        id: 'ticket-settings',
        title: 'Ticket Settings',
        description: 'Customize ticket categories, priorities, and automated responses.',
        iconKey: 'tickets',
        pageKey: 'ticket-settings',
    },

    {
        id: 'route-settings',
        title: 'Route Settings',
        description: 'Configure route types, service zones, and operational statuses.',
        iconKey: 'general',
        pageKey: 'route-settings',
    },
    {
        id: 'support-settings',
        title: 'Support Settings',
        description: 'Configure support email and phone number for passenger and driver apps.',
        iconKey: 'tickets',
        pageKey: 'support-settings',
    },
];

export default function Settings({ onNavigate }) {
    return (
        <div className="settings-page">
            <div className="settings-header">
                <h1 className="settings-title">Settings</h1>
                <p className="settings-subtitle">Manage your account and platform configurations.</p>
            </div>

            <div className="settings-grid">
                {settingsCards.map((card) => (
                    <div
                        key={card.id}
                        className="settings-card"
                        onClick={() => onNavigate(card.pageKey)}
                    >
                        <div className="settings-card-icon">
                            <Icon d={icons[card.iconKey]} size={24} />
                        </div>
                        <div className="settings-card-content">
                            <h3 className="settings-card-title">{card.title}</h3>
                            <p className="settings-card-desc">{card.description}</p>
                        </div>
                        <div className="settings-card-arrow">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 18l6-6-6-6" />
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
